import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const agencyApi = {
  // lay danh sach dai ly
  getAgencyList: (params = {}) => {
    const url = '/agency';
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // lay danh sach dai ly con
  getSubAgencyList: (agencyId, params = {}) => {
    const url = `/agency/${agencyId}/subAgencies`;
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // lay thong tin chi tiet dai ly
  getAgencyDetail: (agencyId) => {
    const url = `/agency/${agencyId}`;
    return axiosClient.get(url);
  },

  // tao dai ly
  createAgency: (params) => {
    const url = '/agency/create';
    return axiosClient.post(url, params);
  },

  // cap nhat thong tin dai ly
  updateAgency: (agencyId, params) => {
    const url = `/agency/${agencyId}`;
    return axiosClient.put(url, params);
  },

  // xoa dai ly
  deleteAgency: (agencyId) => {
    const url = `/agency/${agencyId}`;
    return axiosClient.delete(url);
  },

  // lay danh sach dai ly con
  getSubAgenciesList: (agencyId, params) => {
    const url = `/agency/${agencyId}/subAgencies`;
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // lay cay dai ly
  getAgencyTree: (agencyId, params) => {
    const url = `/agency/tree/${agencyId}`;
    return axiosClient.get(url, { params });
  },

  // tao agency commission
  createAgencyCommission: (params) => {
    const url = '/agency/commission/create';
    return axiosClient.post(url, params);
  },

  // update agency commission
  updateAgencyCommission: (commissionId, params) => {
    const url = `/agency/commission/${commissionId}`;
    return axiosClient.put(url, params);
  },

  // dang ky tai khoan dai ly
  registerAgencyAccount: (params) => {
    const url = '/agency/register';
    return axiosClient.post(url, params);
  },

  getMonthlySale: (params) => {
    const url = '/sale/getMonthlySale';
    return axiosClient.post(url, params);
  },

  getAgencyPaymentTransaction: (params) => {
    const url = `/agency/payment/transactions`;
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  updateAgencyTransaction: (params) => {
    const url = '/agency/processWithdraw';
    return axiosClient.post(url, params);
  },

  getAgencyWithdrawTransaction: (params) => {
    const url = `/agency/withdraw/requests`;
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  getSaleKPIList: (params) => {
    const url = `/sale/kpi`;
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // dat lai mat khau (agency)
  resetPasswordAgency: (params) => {
    const url = `/agency/resetAgencyPassword`;
    return axiosClient.post(url, params);
  },

  // tao KPI thang
  createSaleKPI: (params) => {
    const url = '/sale/kpi';
    return axiosClient.post(url, params);
  },

  // cap nhat KPI thang
  updateSaleKPI: (kpiId, params) => {
    const url = `/sale/kpi/${kpiId}`;
    return axiosClient.put(url, params);
  },

  // xoa KPI thang
  deleteSaleKPI: (kpiId) => {
    const url = `/sale/kpi/${kpiId}`;
    return axiosClient.delete(url);
  },
};

export default agencyApi;
